import * as React from 'react';
import { PageData } from '../../models/utilities/paged-request';
import { EmptyTable } from './EmptyTable';
import { MoreResults } from './MoreResults';
import { TablePager } from './TablePager';

// #region Component Props

interface IProps {
    header                  : string[];
    // A class for the heading of each column, such as table-cell-center to line it up with centered cells
    headerClasses?          : string[];
    tableClass?             : string;
    children                : any;
    noResultsMessage        : string;
    // Generic Optional Props
    numberOfColumns?        : number;
    icon?                   : string;
    transparentBackground?  : boolean;
    numberOfActions?        : number;
    rowClass?               : string;
    // For Load More Button
    onMoreClick?            : any;
    hasMoreResults?         : boolean;
    // For Pagination
    pageData?               : PageData;
    previousClick?          : any;
    nextClick?              : any;
}

// #endregion

const Table : React.SFC<IProps> = (props) => {

    const { 
        header, 
        headerClasses,
        children, 
        tableClass,
        numberOfColumns, 
        numberOfActions,
        rowClass,
        noResultsMessage, 
        icon, 
        transparentBackground,
        pageData, 
        previousClick, 
        nextClick, 
        onMoreClick, 
        hasMoreResults 
    } = props;

    const colCount = numberOfColumns ? numberOfColumns : header.length;
    const trueIcon = icon ? icon : 'la-search';

    const actionClass = numberOfActions ? `buttons-${numberOfActions}` : '';
    const thRowClass = rowClass ? rowClass : '';

    return <table className={"table table-hover " + tableClass }>
                <thead>
                    <tr className={thRowClass}>
                    { 
                        header.map((itm: string, idx: number) => (
                            <th className={ [headerClasses?.[idx], idx === header.length - 1 ? actionClass : ''].filter(Boolean).join(' ') } key={`${ itm }-${ idx}`}>
                                { itm }
                            </th>
                        ))
                    }
                    </tr>
                </thead>
                <tbody>
                {
                    (!children || children.length === 0)
                        ? <EmptyTable 
                            transparent={ transparentBackground } 
                            icon={ trueIcon } 
                            columns={ colCount } 
                            message={ noResultsMessage } />
                        : children
                }        
                </tbody>
                {
                    onMoreClick ?  
                    <MoreResults
                        text="Load More"
                        hasMoreResults={ hasMoreResults ? hasMoreResults : false }
                        onClick={ onMoreClick } /> : null
                }
                {
                    nextClick ?
                    <tfoot>
                        <tr>
                            <td colSpan={ colCount }>
                                <TablePager 
                                    pageData={ pageData! } 
                                    onPrevClick={ previousClick } 
                                    onNextClick={ nextClick } 
                                />
                            </td>
                        </tr>
                    </tfoot> : null
                }            
            </table>;      
};

Table.defaultProps = {
    // Generic Optional Props
    numberOfColumns: 0,
    tableClass: '',
    icon: '',
    transparentBackground: false,
    numberOfActions: 0,
    rowClass: '',

    // For Load More Button
    onMoreClick: undefined as any,
    hasMoreResults: false,

    // For Pagination
    pageData: new PageData(),
    previousClick: undefined as any,
    nextClick: undefined as any
};

export { Table };
